import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { InputWrapper, Label, TextAreaInput, SaveLoaderWrapper, SaveLoaderTitle } from './TextArea.elements'

// Views
import { Image } from 'views/components'

// Assets
import SaveIcon from 'assets/images/save.svg'

function TextArea(props) {
  // Destructure
  const { type, label, resize, saveLoading, disabled, ...rest } = props

  return (
    <InputWrapper label={label}>
      {label && <Label disabled={disabled}>{label}</Label>}
      <TextAreaInput disabled={disabled} type={type} resize={resize} {...rest} />
      {saveLoading && (
        <SaveLoaderWrapper>
          <SaveLoaderTitle>Saving...</SaveLoaderTitle>
          <Image src={SaveIcon} width={16} height={16} />
        </SaveLoaderWrapper>
      )}
    </InputWrapper>
  )
}

// Default Props
TextArea.defaultProps = {
  type: '',
  label: '',
  resize: true,
  saveLoading: false,
  disabled: false,
}

// Proptypes Validation
TextArea.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  resize: PropTypes.bool,
  saveLoading: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default TextArea
